module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2007 by Peter Ho Davies")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _c('br'), _vm._v("\nDavies, Peter Ho, date."), _c('br'), _vm._v("\nThe Welsh girl : a novel / Peter Ho Davies."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-618-00700-4"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v("-10: 0-618-00700-8"), _c('br'), _vm._v("\n1. Prisoners of war—Germany—Fiction. 2. Prisoners of war—Wales—Fiction. 3. Young women—Wales—Fiction. 4. World War, 1939–1945—Fiction. 5. Wales—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("6054."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("89145"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v("45 2007"), _c('br'), _vm._v("\n823'.914—dc22 2006015358")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-52490-0"), _c('br'), _vm._v("\nv3.0716")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0